(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lift-cta-cream"] && !Shopify.designMode) return;
  try {
    
(function () {
  function mountShader() {
    var canvas = document.querySelector('.cta-cream-canvas');
    if (!canvas || !window.LIFTShaders) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.ctaFX = window.LIFTShaders.mount(canvas, {
      shader: 'metaballs',
      intensity: reduce ? 0.2 : 0.55,
      pointerTarget: window,
      colors: { c0: canvas.dataset.c0, c1: canvas.dataset.c1, c2: canvas.dataset.c2, c3: canvas.dataset.c3, cc: canvas.dataset.cc }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountShader);
  } else {
    setTimeout(mountShader, 0);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ss = document.querySelector('.js-hero-slideshow');
  if (!ss) return;
  var slides = Array.from(ss.querySelectorAll('.hero-slide'));
  var dots   = Array.from(ss.querySelectorAll('.ss-dot'));
  if (!slides.length) return;
  var current = 0, timer;

  function goTo(n) {
    slides[current].classList.remove('is-active');
    dots[current].classList.remove('is-active');
    dots[current].setAttribute('aria-pressed', 'false');
    current = ((n % slides.length) + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    dots[current].classList.add('is-active');
    dots[current].setAttribute('aria-pressed', 'true');
  }
  function start() {
    clearInterval(timer);
    timer = setInterval(function () { goTo(current + 1); }, 5000);
  }
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(this.dataset.idx, 10));
      start();
    });
  });
  ss.addEventListener('mouseenter', function () { clearInterval(timer); });
  ss.addEventListener('mouseleave', start);
  start();
})();

(function () {
  function mountShader() {
    var canvas = document.querySelector('.hero-shader-canvas');
    if (!canvas || !window.LIFTShaders) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.heroFX = window.LIFTShaders.mount(canvas, {
      shader: 'metaballs',
      intensity: reduce ? 0.5 : 0.82,
      pointerTarget: window,
      colors: { c0: canvas.dataset.c0, c1: canvas.dataset.c1, c2: canvas.dataset.c2, c3: canvas.dataset.c3, cc: canvas.dataset.cc }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountShader);
  } else {
    setTimeout(mountShader, 0);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-projects"] && !Shopify.designMode) return;
  try {
    
function openProjModal(card) {
  var dialog = document.getElementById('proj-' + card.dataset.blockId);
  if (dialog) dialog.showModal();
}
document.querySelectorAll('.pcard').forEach(function(card) {
  card.addEventListener('click', function() { openProjModal(card); });
  card.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openProjModal(card); }
  });
});
document.querySelectorAll('.proj-modal').forEach(function(dialog) {
  var closeBtn = dialog.querySelector('.modal-close');
  if (closeBtn) closeBtn.addEventListener('click', function() { dialog.close(); });
  dialog.addEventListener('click', function(e) { if (e.target === dialog) dialog.close(); });
  dialog.addEventListener('keydown', function(e) { if (e.key === 'Escape') dialog.close(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-stores"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.querySelector('.js-store-filters');
  var grid = document.querySelector('.js-store-grid');
  if (!wrap || !grid) return;
  var buttons = Array.from(wrap.querySelectorAll('.filter'));
  var cards = Array.from(grid.querySelectorAll('.store-card'));

  wrap.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-store-filter]');
    if (!btn) return;
    buttons.forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    var filter = btn.dataset.storeFilter;
    cards.forEach(function (card) {
      var show = filter === 'all' || card.dataset.rubro === filter;
      card.classList.toggle('is-hidden', !show);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lift-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var carousel = document.querySelector('.js-testi-carousel');
  if (!carousel) return;
  var track   = carousel.querySelector('.js-testi-track');
  var dots    = Array.from(carousel.querySelectorAll('.testi-dot'));
  var cards   = Array.from(track.querySelectorAll('.testi-card'));
  if (cards.length <= 1) return;

  var current = 0;
  var timer;

  function perView() {
    var w = window.innerWidth;
    if (w <= 860) return 1;
    if (w <= 1100) return 2;
    return 3;
  }

  function maxIndex() {
    return Math.max(0, cards.length - perView());
  }

  function goTo(n) {
    current = Math.max(0, Math.min(n, maxIndex()));
    var gap = 24;
    var cardW = cards[0].offsetWidth;
    track.style.transform = 'translateX(-' + (current * (cardW + gap)) + 'px)';
    dots.forEach(function (d, i) {
      var active = i === current;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function next() {
    goTo(current >= maxIndex() ? 0 : current + 1);
  }

  function start() {
    clearInterval(timer);
    timer = setInterval(next, 4000);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(this.dataset.idx, 10));
      start();
    });
  });

  carousel.addEventListener('mouseenter', function () { clearInterval(timer); });
  carousel.addEventListener('mouseleave', start);
  window.addEventListener('resize', function () { goTo(current); });

  // Touch / swipe
  var touchStartX = 0;
  var touchStartY = 0;
  var isDragging = false;

  carousel.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isDragging = true;
    clearInterval(timer);
  }, { passive: true });

  carousel.addEventListener('touchend', function (e) {
    if (!isDragging) return;
    isDragging = false;
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) { start(); return; }
    if (dx < 0) {
      goTo(current >= maxIndex() ? 0 : current + 1);
    } else {
      goTo(current <= 0 ? maxIndex() : current - 1);
    }
    start();
  }, { passive: true });

  start();
})();

  } catch(e) { console.error(e); }
})();
})();
